function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.368 14.664H48.04L52.624 6.864H54.952L48.784 17.448V24H46.624V17.448L40.456 6.864H42.784L47.368 14.664ZM76.7819 8.832H66.9659V14.4H74.9099V16.368H66.9659V24H64.8059V6.864H76.7819V8.832ZM89.3768 21.96H99.0008V24H87.2168V6.864H89.3768V21.96ZM109.514 6.864H111.674V24H109.514V6.864ZM135.294 6.864H137.406V24H133.998L126.03 9.672H125.502V24H123.39V6.864H126.798L134.766 21.192H135.294V6.864ZM148.965 24V6.864H151.125V15.36L159.933 6.864H162.573L157.197 12.24L163.221 24H160.917L155.781 14.112H155.253L151.125 18.072V24H148.965Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 30.4824C23.2843 30.4824 30 23.7667 30 15.4824C30 7.19815 23.2843 0.482422 15 0.482422C6.71573 0.482422 0 7.19815 0 15.4824C0 23.7667 6.71573 30.4824 15 30.4824Z",
  fill: "#2A5BDB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1936 7.95276L18.7078 8.4728L19.2423 10.1547L14.8158 7.86609L8.81885 11.1617V15.6068L11.2251 14.7545L11.2085 12.5402L14.8158 10.6252L18.2621 12.307L16.541 12.9406L17.0858 14.4924L21.8384 12.7941L20.1936 7.95276Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.42939 22.8978L10.9152 22.3757L10.3807 20.6938L14.8052 22.9824L20.8021 19.6889V15.2438L18.398 16.094L18.4145 18.3083L14.8052 20.2254L11.3589 18.5435L13.08 17.9079L12.5352 16.3581L7.78467 18.0545L9.42939 22.8978Z",
  fill: "white"
});

function SvgYflinkFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 31,
    viewBox: "0 0 165 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYflinkFull);
export default __webpack_public_path__ + "static/media/yflink-full.d4826407.svg";
export { ForwardRef as ReactComponent };